const CLOUDINARY_CLOUD_NAME =
  process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || "dspivvtjd";
const CLOUDINARY_UPLOAD_PRESET =
  process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || "cunghome";
const CLOUDINARY_URL = `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/auto/upload`;

export const uploadMediaToCloudinary = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
  formData.append('cloud_name', CLOUDINARY_CLOUD_NAME);

  const res = await fetch(CLOUDINARY_URL, {
    method: "POST",
    body: formData,
  });
  const data = await res.json().catch(() => ({}));

  if (!res.ok || !data.secure_url) {
    throw new Error(data.error?.message || `Cloudinary trả về lỗi ${res.status}`);
  }

  return data.secure_url;
};

export const createUploadHandler = (setIsUploading) => ({
  single: async (e, callback) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setIsUploading(true);
    try {
      const url = await uploadMediaToCloudinary(file);
      callback(url);
    } catch (error) {
      console.error("Lỗi upload media:", error);
      alert(`Không thể tải file lên: ${error.message}`);
      e.target.value = "";
    } finally {
      setIsUploading(false);
    }
  },

  multiple: async (e, callback) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    setIsUploading(true);

    try {
      const uploadPromises = Array.from(files).map(file =>
        uploadMediaToCloudinary(file)
      );
      const urls = await Promise.all(uploadPromises);
      callback(urls.join(", "));
    } catch (error) {
      console.error("Lỗi upload media:", error);
      alert(`Không thể tải file lên: ${error.message}`);
      e.target.value = "";
    } finally {
      setIsUploading(false);
    }
  },
});
